import { useEffect, useState } from "react";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import {
  CheckedCheckboxIcon,
  UncheckedCheckboxIcon,
} from "@/pages/search/filters/checkbox-filter/icons";

interface CustomCheckboxProps extends React.ComponentProps<"input"> {}

export function CustomCheckbox({
  children,
  className,
  ...props
}: CustomCheckboxProps) {
  const [isChecked, setIsChecked] = useState(
    props.defaultChecked ?? props.checked ?? false
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
    props.onChange?.(e);
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: no need no loop
  useEffect(() => {
    setIsChecked(props.defaultChecked ?? props.checked ?? isChecked);
  }, [props.defaultChecked, props.checked]);

  return (
    <Label className={className}>
      <Input
        {...props}
        className="hidden"
        onChange={handleChange}
        type="checkbox"
      />
      <div className="flex flex-row-reverse items-center justify-end">
        {!!children && (
          <p className="text-16 leading-[1.2em] md:text-14">{children}</p>
        )}
        <div className={cn("relative", !!children && "mr-2.5")}>
          <UncheckedCheckboxIcon
            className={cn(
              "transition-opacity",
              isChecked ? "opacity-0" : "opacity-100"
            )}
          />
          <CheckedCheckboxIcon
            className={cn(
              "absolute inset-0 transition-opacity",
              isChecked ? "opacity-100" : "opacity-0"
            )}
          />
        </div>
      </div>
    </Label>
  );
}

export default CustomCheckbox;
